import config from './production'
import { isWeb } from '@volt-libs/foundation'

const conf = {
    ...config,
    urls: {
        ...config.urls,
        emi: {
            baseUrl: 'https://emi-api-starhub-dev-beta.ifeelsmart.net',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'default_dev',
        },
        proxyUrl: 'https://starhub-alpha-api.ifeelsmart.net/maculosa/v3.1',
    },
    encryption: {
        enabled: false,
    },
    env: 'development',
    firebaseConfig: {
        enabled: true,
        apiKey: `${isWeb ? 'AIzaSyAS9v7QFMJ7WjVMrE1OWYVeJKBjiZVbjDM' : 'AIzaSyBRHNdU06_a71J6f0WM1hZlcr2AD_Reg9s'}`,
        authDomain: "starhub-ifs-uat.firebaseapp.com",
        projectId: "starhub-ifs-uat",
        storageBucket: `${isWeb ? 'starhub-ifs-uat.appspot.com' : 'starhub-ifs-uat.firebasestorage.app'}`,
        messagingSenderId: "359855094350",
        appId: `${isWeb ? '1:359855094350:web:5dd6ac3a564e9d9ce6a11f' : '1:359855094350:web:aca86ddf73dca762e6a11f'}`,
        measurementId: `${isWeb ? 'G-PK9WDYV3C2' : 'G-YKCCV7MTXT'}`
    },
    conviva: {
        enable: true,
        customerKey: 'ce72c24b6cec8e868419d5093b7822a11707ae42',
        gatewayUrl: 'https://ce72c24b6cec8e868419d5093b7822a11707ae42.ts-testonly.conviva.com',
        logLevel: 0,
        applicationName: 'webStv',
    },
    showBingeWatch : true,
    adobeAnalytics: {
        enabled: true,
        analyticsUserUrl: 'https://dpm.demdex.net/id',
        analyticsApiUrl: 'https://mediacorp.hb-api.omtrdc.net/api/v1',
        trackingServer: 'mediacorp.sc.omtrdc.net',
        reportSuit: 'mediacorp-dtm-uat',
        organisationId: 'B464317853A9C8390A490D4E@AdobeOrg',
        apiVersion: 2,
        pingPeriodMsecs: 10000,
    },
}

export default conf
